<template>
  <div>
    <div v-show="emsl == 0">
      <!-- 骨架屏 -->
      <skeleton-screen v-show="!dataLoaded"></skeleton-screen>
      <div v-if="dataLoaded" class=" col-md-12 col-sm-12 col-lg-12 col-xl-12  pl-0 pr-0 ml-0 pr-0 lieb scroll-container sjbtop mb-4" style="width: calc(100% - 1vw)" ref="scrollContainer">
        <div v-if="show == 0" style="width: 100%;" id="zhixingld">
          <div class="sjyinc" style="width: 100%;">
            <div style="width: 100%;position: relative;">
              <div @click="fczff(hot.id)" class="position-absolute curpo" style="z-index: 9; color: white;left: 7%;top: 3%;width: 93%;">
                <div class="col-md-5 pl-0 pr-0 mb-1" style="font-size: calc(10px + 0.4vw);">{{
                                      hot.small_title }}
                </div>
                <div class="mb-2 col-md-5 pl-0 pr-0 sjbxzt" style="font-size: calc(15px + 0.4vw);font-weight: 700;">{{ hot.title }}</div>
                <div class="col-md-5 pl-0 pr-0 sjbzt" style="font-size: calc(8px + 0.4vw);font-weight: 500;">{{ hot.sub_title }}</div>
                <div class="ckqbb yuanjiao pt-2 pb-2 mt-1 sjbxzt" style="width: 25%;background-color: #FFD672;text-align: center;font-size: calc(7px + 0.4vw);color: #000;">
                  {{ $t('查看详情') }}
                </div>
              </div>
              <div class="curpo" style="width: 100%;">
                <img @click="fczff(hot.id)" class=" curpo yuanjiao" :src="hot.hot_image" style=" width: 100%;height: 20vh;object-fit: cover;" alt="" />
              </div>

              <div class=" mt-3 d-flex pl-0 pr-0 justify-content-around align-items-center" style="width: 100%;">
                <div class=" pl-0 pr-0 " style="width: 32%;">
                  <div class="yuanjiao baise p-2">
                    <div class="d-flex align-items-center mb-1">
                      <div class="mr-1"><img style="width: calc(15px + 0.5vw);" src="@/img/icon_leijijuankuan@2x (2).png" alt="" /></div>
                      <div class="" style="font-size: calc(9px + 0.4vw);font-weight: 500;">{{ $t('累積參與人次') }}</div>
                    </div>
                    <div style="font-size: calc(11px + 0.4vw);font-weight: 600;">
                      {{ xasddinfo.virtual_people.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                    </div>
                  </div>
                </div>
                <div class=" pl-0 pr-0 " style="width: 32%;">
                  <div class="yuanjiao baise p-2">
                    <div class="d-flex align-items-center mb-1">
                      <div class="mr-1"><img style="width: calc(15px + 0.5vw);" src="@/img/daohangl/pic_hssy_haorenbi@2x.png" alt="" /></div>
                      <div class="" style="font-size: calc(9px + 0.4vw);font-weight: 500;">{{ $t('累積好人積分') }}</div>
                    </div>
                    <div style="font-size: calc(11px + 0.4vw);font-weight: 600;">
                      {{ xasddinfo.sum_goods_coin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                    </div>
                  </div>
                </div>
                <div class=" pl-0 pr-0 " style="width: 32%;">
                  <div class="yuanjiao baise p-2">
                    <div class="d-flex align-items-center mb-1">
                      <div class="mr-1"><img style="width: calc(15px + 0.5vw);" src="@/img/daohangl/pic_hssy_tanbi@2x.png" alt="" /></div>
                      <div class="" style="font-size: calc(9px + 0.4vw);font-weight: 500;">{{ $t('累積碳積分') }}</div>
                    </div>
                    <div style="font-size: calc(11px + 0.4vw);font-weight: 600;">
                      {{ xasddinfo.sum_carbon_coin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="yinc col-sm-12 pl-0 pr-0 d-flex justify-content-between">
            <div class="col-md-12 col-sm-12 col-xl-9 pl-0 pr-0">
              <div class="col-md-12 pl-0 pr-0">
                <div @click="fczff(hot.id)" class=" pl-0 pr-0 position-absolute curpo" style="z-index: 99; color: white;left: 7%;top: 13%;width: 93%;">
                  <div class="col-md-8 pl-0 pr-0 mb-2" style="font-size: calc(10px + 0.4vw);">{{
                                      hot.small_title }}
                  </div>
                  <div class="mb-2 col-md-8 pl-0 pr-0" style="font-size: calc(22px + 0.4vw);font-weight: 700;">{{ hot.title }}</div>
                  <div class="col-md-8 pl-0 pr-0" style="font-size: calc(15px + 0.4vw);font-weight: 500;">{{ hot.sub_title }}</div>
                  <div class="col-sm-2 pl-0 pr-0 ckqbb yuanjiao pt-3 pb-3 mt-5" style="background-color: #FFD672;text-align: center;font-size: calc(7px + 0.4vw);color: #000;">
                    {{ $t('查看详情') }}
                  </div>
                </div>
                <div class="col-sm-12 pl-0 pr-0 curpo" style="">
                  <img @click="fczff(hot.id)" class=" curpo yuanjiao" :src="hot.image" style=" width: 100%;height: 300px;object-fit: cover;" alt="" />
                </div>
                <div class=" mt-3 d-flex pl-0 pr-0 justify-content-around align-items-center" style="width: 100%;">
                  <div class=" pl-0 pr-0 " style="width: 32%;">
                    <div class="yuanjiao baise p-3 d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <div class="mr-2"><img style="width: calc(15px + 0.5vw);" src="@/img/icon_leijijuankuan@2x (2).png" alt="" /></div>
                        <div class="sjbzt" style="font-size: calc(10px + 0.4vw);font-weight: 500;">{{ $t('累積參與人次') }}</div>
                      </div>
                      <div style="font-size: calc(10px + 0.4vw);font-weight: 600;">
                        {{ xasddinfo.virtual_people.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                      </div>
                    </div>
                  </div>
                  <div class=" pl-0 pr-0 " style="width: 32%;">
                    <div class="yuanjiao baise p-3 d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <div class="mr-2"><img style="width: calc(15px + 0.5vw);" src="@/img/daohangl/pic_hssy_haorenbi@2x.png" alt="" /></div>
                        <div class="sjbzt" style="font-size: calc(10px + 0.4vw);font-weight: 500;">{{ $t('累積好人積分') }}</div>
                      </div>
                      <div style="font-size: calc(10px + 0.4vw);font-weight: 600;">
                        {{ xasddinfo.sum_goods_coin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                      </div>
                    </div>
                  </div>
                  <div class=" pl-0 pr-0 " style="width: 32%;">
                    <div class="yuanjiao baise p-3 d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <div class="mr-2"><img style="width: calc(15px + 0.5vw);" src="@/img/daohangl/pic_hssy_tanbi@2x.png" alt="" /></div>
                        <div class="sjbzt" style="font-size: calc(10px + 0.4vw);font-weight: 500;">{{ $t('累積碳積分') }}</div>
                      </div>
                      <div style="font-size: calc(10px + 0.4vw);font-weight: 600;">
                        {{ xasddinfo.sum_carbon_coin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="yuanjiao col-xl-3 yinc ml-0 pr-0 leftSidebarBox" ref="leftSidebarBox" style="position: fixed;right: 1.8vw;flex:1;max-width:20vw;top:9vh;max-height: 86.5vh;overflow-y: auto;">
              <div class="baise col-md-12 pb-2 yuanjiao pl-0 pr-0 " style="height: 86.5vh;">
                <div class="mb-2 d-flex justify-content-between ml-3 mr-3 pt-3" style="font-size: calc(8px + 0.4vw); font-weight: 500">
                  <div>{{ $t("最新捐贈物品") }}</div>
                </div>
                <div class="mb-2 ml-3 mr-3 col-md-11" style="height: 1px; background: #e5e5e5"></div>
                <div @click="fczff(item.id)" v-for="(item, index) in used" :key="index" class="d-flex  justify-content-between ckqbb curpo align-items-center mb-2 xunafuxgio pl-3 pr-3 pt-2 pb-2 yuanjiao">
                  <div class="d-flex justify-content-between align-items-center">
                    <img class="mr-2" style="width: calc(35px + 0.5vw);height: calc(35px + 0.4vw);border-radius: 50%;object-fit: cover;" :src="item.goods_img[0].img_url.url" alt="" />
                    <div>
                      <div class="ellipsis" style="font-size: calc(7px + 0.4vw);">
                        {{ item.name?item.name:'' }}
                      </div>
                      <div class="d-flex align-items-center mt-1">
                        <div class="d-flex mr-2 align-items-center" style="font-size: calc(6px + 0.4vw);color: #666666;">
                          <img style="width: calc(7px + 0.5vw);height: calc(7px + 0.5vw);" src="@/img/icon_shsy_zdh_jkhd@2x (1).png" alt="" />
                          <div class="ml-1">{{ item.surplus_number ? item.surplus_number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <img style="width: calc(15px + 0.5vw)" src="@/img/daohangl/icon_hssy_hdlb_xiangqing@2x.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <wzrl ref="fczdf" @custom='custom' @emslfun='emslfun' :allList="donation" :ids="isids"></wzrl>
        
      </div>
    </div>
    <div v-if="showImage" class="curpo" style="position: fixed;right: 5%;bottom: 10%;">
      <img @click="scrollToSection('zhixingld')" style="width: calc(36px + 0.4vw);height: calc(36px + 0.4vw);" src="@/img/icon_hssy_zhiding@2x.png" alt="">
    </div>
  </div>
</template>
  
  <script>
import { new_list, period_result } from "@/request/aapi.js";
import { formatTimestamp } from "@/utils/common.js";
import SkeletonScreen from "./SkeletonScreen/jkhdSkeletonScreen.vue";
import wzrl from "@/components/wzrl/index.vue";
import { EventBus } from "@/views/event-bus.js";
export default {
  components: {
    SkeletonScreen,
    wzrl,
  },
  data() {
    return {
      emsl: 0,
      show: 0,
      xasddinfo: {},
      modalShow: false,
      dataLoaded: false,
      isDropdownOpen: false, // 控制Dropdown的显示
      istoggleDropdownm: false,
      showImage: false, // 是否显示图片
      isLoading: false,
      jhuxa: this.$t("全部"),
      tdjhuxa: this.$t("团队类型"),
      items: [
      ],
      hdlb: [{}, {}, {}, {}, {}],
      donation: [],
      hot: [],
      tkdsj: {},
      remark: [],
      used: [],
      isids: null,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.getDonation_list();
    setTimeout(() => {
      this.checkSidebar();
      EventBus.$on('check-sidebar', this.checkSidebar);
    }, 1000);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    EventBus.$off('check-sidebar', this.checkSidebar);
  },
  methods: {
    checkSidebar() {
      this.$nextTick(() => {
        const exists = !!this.$refs.leftSidebarBox;
        EventBus.$emit('sidebar-status', exists);
      });
    },
    scrollToSection(sectionId) {
      this.sectionId = sectionId;
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    handleScrolls() {
      const container = this.$refs.scrollContainer;
      const scrollTop = container.scrollTop;
      const containerHeight = container.clientHeight;
      if (scrollTop >= containerHeight) {
        this.showImage = true;
      } else {
        this.showImage = false;
      }
    },
    handleScroll() {
      const scrollTop = window.scrollY; 
      const clientHeight = window.innerHeight;
      const scrollHeight = document.documentElement.scrollHeight;
      if (scrollTop > clientHeight) {
        this.showImage = true;
      } else {
        this.showImage = false;
      }
      if (scrollTop + clientHeight >= scrollHeight) {
        this.$refs.fczdf.gundong();
      }
    },
    timeFilter(stringTime) {
      return formatTimestamp(stringTime * 1000);
    },
    async period_result() {
      const { data } = await period_result({
        order_no: this.$route.query.order_no,
      });
      this.tkdsj = data.info;
      this.modalShow = true;
    },
    chakanxq(e) {
      this.$refs.fczdf.smdckxq(e);
    },
    getDonation_list() {
        new_list().then((res) => {
        if (res.code == 200) {
          this.xasddinfo = res.data;
          this.dataLoaded = true;
        //   this.donation = res.data.donation;
          this.hot = res.data.img_info;
        //   this.remark = res.data.remark;
          this.used = res.data.data;
        }
      });
    },

    funs(e) {
      this.$router.push("/members/point-logs");
    },
    xindfanhui(e) {
      this.emsl = e;
    },
    emslfun(e) {
      console.log(e, "2222222");
      if (e == 1) {
        setTimeout(() => {
          this.$refs.inmn.getInfo();
        }, 1000);
      }
      this.emsl = e;
    },

    fczff(a) {
      this.isids = this.hot.id;
      // this.$refs.fczdf.fun(1);
      this.$router.push({
        path: "claim/item/" + a,
      });
    },
    custom(e) {
      this.show = e;
    },
    tiaozhuan() {
      this.$router.push("/groups/groupdetails");
    },
    xuanz(e) {
      this.jhuxa = e;
      this.isDropdownOpen = false;
    },
    tdxuanz(e) {
      this.tdjhuxa = e;
      this.istoggleDropdownm = false;
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
      // 如果需要，可以在这里添加Bootstrap Dropdown的额外处理逻辑
    },
    toggleDropdownm() {
      this.istoggleDropdownm = !this.istoggleDropdownm;
      // 如果需要，可以在这里添加Bootstrap Dropdown的额外处理逻辑
    },
  },
};
</script>
  <style >
.custom-modal-widths .modal-dialog {
  position: relative;
  max-width: 50% !important;
  margin: auto;
  pointer-events: none;
}
@media screen and (max-width: 995px) {
  .custom-modal-widths .modal-dialog {
    position: relative;
    max-width: 90% !important;
    margin: auto;
    pointer-events: none;
  }
  .sjbtop{
    padding-top: 1rem !important;
  }
}
</style>
  <style scoped lang="scss">
@media screen and (max-width: 995px) {
  .sjyinc {
    display: block !important;
  }
  .yinc {
    display: none !important;
  }
  .heggs {
    margin-top: 1rem !important;
  }
  .heggs {
    height: 79vh !important;
  }
  .sjbzt {
    font-size: calc(14px + 0.4vw) !important;
  }
  .sjbxzt {
    font-size: calc(11px + 0.4vw) !important;
  }
  .sjbxxzt {
    font-size: calc(9px + 0.4vw) !important;
  }
}
.heggs {
  height: 89.5vh;
}
.sjyinc {
  display: none;
}
.annys {
  font-size: calc(6px + 0.4vw);
  background: #ffd672;
  width: 144px;
  margin: auto;
  border: none;
}

.inppt {
  background: white;
  border: none;
  border-radius: 13px;
  font-size: calc(7px + 0.4vw);
  padding-top: 22px;
  padding-bottom: 22px;
}

.zhankai {
  background: #ffebd2;
  text-align: center;
  border-radius: 12px 12px 12px 12px;
  border: none;
  font-weight: 400;
  font-size: calc(6px + 0.4vw);
  color: #1a1a1a;
}

.form-control {
  height: calc(15px + 0.5vw) !important;
}

.sxbj {
  padding-top: calc(15px + 0.5vw);
  padding-bottom: calc(15px + 0.5vw);
}

.ckqbb:hover {
  transform: scale(1.001);
  /* 悬浮时放大1.1倍 */
  // padding: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.ckq:hover {
  transform: scale(1.001);
  /* 悬浮时放大1.1倍 */
  font-weight: 800;
}

.sbxfbd:hover {
  transform: scale(1.1);
}
.dropdown-menu {
  min-width: calc(130px + 0.5vw) !important;
  font-size: calc(8px + 0.4vw) !important;
}
.xlcd {
  display: block;
  background: #ffebd2;
  border: none;
}
.ckqbb:hover {
  transform: scale(1.001);
  /* 悬浮时放大1.1倍 */
  // padding: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
/* 隐藏水平滚动条 */
.lieb::-webkit-scrollbar {
  display: none;
}

.ellipsis-multiline {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dydpd {
  padding-top: calc(7px + 0.4vw);
  padding-bottom: calc(7px + 0.4vw);
  padding-left: calc(10px + 0.5vw);
  padding-right: calc(10px + 0.5vw);
}
.dropdown-item:hover {
  background-color: #ffebd2;
  color: #b66d00;
  border-radius: 12px;
}
.dropdown-item{
  text-align: left;
}
.tkd {
  font-size: calc(10px + 0.4vw);
  font-weight: 700;
}
.tkx {
  font-size: calc(7px + 0.4vw);
  color: #666666;
}
.xiaod {
  font-size: calc(8px + 0.4vw);
  font-weight: 700;
  width: 25%;
}
.bdxian {
  height: 1px;
  width: 100%;
  background: #1a1a1a;
}
</style>